module.exports = __webpack_public_path__ + "static/media/9.e5d39283.png";